export function formatDatabaseDate(value) {
    if (!value) return ''
    const date = new Date(value)
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
}

export function formatDate(value) {
    if (!value) return '';
    
    // Parse a string como "2024-06-03T15:46:26Z"
    const date = new Date(value);
    
    // Obter partes individuais da data
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Mês é 0-based
    const year = date.getUTCFullYear();
    
    // Retornar apenas a data no formato desejado
    return `${day}/${month}/${year}`;
}